// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "modal__top_wrapper-1SdWJ";
var _5 = "modal__content-29HAf";
var _6 = "modal__paper-1CaZC";
var _7 = "dates-16Qon";
var _8 = "wrapper-2p-zL";
var _9 = "container-3KHNW";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "modal__top_wrapper", _5 as "modal__content", _6 as "modal__paper", _7 as "dates", _8 as "wrapper", _9 as "container" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "modal__top_wrapper": _4, "modal__content": _5, "modal__paper": _6, "dates": _7, "wrapper": _8, "container": _9 }
